// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import PageTitle from '../components/PageTitle';
import PaginatedSearchResultsTable from '../components/PaginatedSearchResultsTable';
import riaFirmColumns from '../constants/riaFirmColumns';
import { riaFirmReportTypes } from '../constants/reportTypes';
import iarColumns from '../constants/iarColumns';
import { iarReportTypes } from '../constants/reportTypes';
import RiaFirmDetailsModal from '../components/RiaFirmDetailsModal';
import IarDetailsModal from "../components/IarDetailsModal";
import { riaFirmExecutiveReportTypes } from '../constants/reportTypes';
import riaFirmExecutiveColumns from '../constants/riaFirmExecutiveColumns'
import BdFirmDetailsModal from '../components/BdFirmDetailsModel';
import RRIndivDetailsModal from '../components/RRIndivDetailsModel';

class RiaFirmSearchResultsPage extends React.Component {
    static propTypes = {
        // this is the redux stored form states, for all forms
        allFormStates: PropTypes.object,
    };
    constructor(props) {
        super(props);
        this.state = {
            showAgentDetailsModal: false,
            agentDetailsId: null,
            riaDetailsId: null,
            iarDetailsId: null,
            IarModal: false,
            hasProfileModel: null,
            rowId: null,
            iarRowId: null,
            iarIndivDetailsModal: false,
            bdRiaRowId: null,
            bdRiaModel: false,
            RRBdRowId: null,
            RRBdModal: false,
            RRIarModal: false,
            RRIarRowId: null,
        }
        this.handleIndividualDetails = this.handleIndividualDetails.bind(this);
        this.handleDetailsModalClose = this.handleDetailsModalClose.bind(this);
        this.handleIarIndividualDetails = this.handleIarIndividualDetails.bind(this);
        this.handleIarDetailsModalClose = this.handleIarDetailsModalClose.bind(this);
        this.onIarIndividualDetails = this.onIarIndividualDetails.bind(this);
        this.onBdModalChanged = this.onBdModalChanged.bind(this);
        this.onBdIarIndividualDetails = this.onBdIarIndividualDetails.bind(this);
        this.onBdRRIndividualDetails = this.onBdRRIndividualDetails.bind(this);
        this.onBdIarRRIndividualDetails = this.onBdIarRRIndividualDetails.bind(this);
    }

    handleIndividualDetails(id, rowValues=[], onClickValues) {
        this.setState({
            showAgentDetailsModal: true,
            RRBdModal: false,
            agentDetailsId: id,
            riaDetailsId: rowValues,
            iarDetailsId: onClickValues,
        })
    }

    handleDetailsModalClose() {
        this.setState({
            showAgentDetailsModal: false,
            agentDetailsId: null,
            riaDetailsId: null,
            iarDetailsId: null,
            RRBdModal: false,
            RRIarModal: false,
        })
    }

    handleIarIndividualDetails(id, hasIarProfile, rowvalues) {
        this.setState({
            iarIndivDetailsModal: true,
            hasProfileModel: hasIarProfile,
            riaDetailsId: hasIarProfile,
            iarDetailsId: rowvalues,
            showAgentDetailsModal: false,
            IarModal: false,
            rowId: id,
        })
    }

    handleIarDetailsModalClose() {
        this.setState({
            iarIndivDetailsModal: false,
            IarModal: false,
            rowId: null,
            hasProfileModel: null,
        })
    }

    onIarIndividualDetails(id,hasIarProfile) {
        this.setState({
            IarModal: false,
            iarIndivDetailsModal: false,
            showAgentDetailsModal: true,
            agentDetailsId: id,
            hasProfileModel: null,
            iarDetailsId: hasIarProfile,
        })
    }

    onBdModalChanged(id) {
        this.setState({
            showAgentDetailsModal: true,
            iarDetailsId: id,
        })
    }

    onBdIarIndividualDetails(id, hasIarProfile) {
        this.setState({
            IarModal: true,
            iarIndivDetailsModal: false,
            showAgentDetailsModal: false,
            bdRiaRowId: id,
            hasProfileModel: null,
            hasProfileModel: hasIarProfile,
        })
    }

    onBdRRIndividualDetails(id, onClickValues) {
        this.setState({
            RRBdModal: true,
            iarDetailsId: onClickValues,
            showAgentDetailsModal: false,
            iarIndivDetailsModal: false,
            RRBdRowId: id,
            hasProfileModel: null,
            RRIarModal: false,
        })
    }

    onBdIarRRIndividualDetails(id, rowValues=[], onClickValues) {
        this.setState({
            RRIarModal: true,
            showAgentDetailsModal: false,
            iarIndivDetailsModal: false,
            RRBdModal: false,
            RRIarRowId: id,
            hasProfileModel: null,
            riaDetailsId: rowValues,
            iarDetailsId: onClickValues,
        })
    }

    render() {
        const searchFormProps = this.props.allFormStates.riaFirmSearch;
        // Added condition for showing the Firm and Individual data in RIA result page
        let search_executive = searchFormProps.formState.search_executive

        return <>
            <PageTitle title="<< Back to RIA Firm Search" className="btn"
                    onClick={() => this.props.history.push("/riafirm/search")} />

            <PaginatedSearchResultsTable
                searchFormState={searchFormProps.formState}
                recordCount={searchFormProps.rowCount}
                reportTypes={search_executive?riaFirmExecutiveReportTypes:riaFirmReportTypes}
                possibleColumns={search_executive?riaFirmExecutiveColumns:riaFirmColumns}
                detailsModalComponent={search_executive?IarDetailsModal:RiaFirmDetailsModal}
                enableSaving={true}
                recordCount={searchFormProps.rowCount}
                onModalChanged={search_executive ? this.onBdRRIndividualDetails : this.handleIndividualDetails}
                onIrModalChanged={search_executive ? this.handleIarIndividualDetails : this.onIarIndividualDetails}
                onBdModalChanged={this.onIarIndividualDetails}
                listRow={this.state.iarDetailsId}
            />
            {!search_executive &&
                <IarDetailsModal
                    isOpen={this.state.showAgentDetailsModal}
                    rowId={this.state.agentDetailsId}
                    listValue={this.state.riaDetailsId}
                    rowIndiv={this.state.iarDetailsId}
                    onIrModalChanged={this.handleIarIndividualDetails}
                    onModalChanged={this.onBdRRIndividualDetails}
                    onClickChanged={this.handleIndividualDetails}
                    onClose={this.handleDetailsModalClose}
                />}

            {search_executive &&
                <IarDetailsModal
                    isOpen={this.state.RRIarModal}
                    rowId={this.state.RRIarRowId}
                    listValue={this.state.riaDetailsId}
                    rowIndiv={this.state.iarDetailsId}
                    onModalChanged={this.onBdRRIndividualDetails}
                    onIrModalChanged={this.handleIarIndividualDetails}
                    onClickChanged={this.onBdIarRRIndividualDetails}
                    onClose={this.handleDetailsModalClose}
                />}
            {search_executive &&
                <RiaFirmDetailsModal
                    isOpen={this.state.RRBdModal}
                    rowId={this.state.RRBdRowId}
                    listRow={this.state.iarDetailsId}
                    onModalChanged={this.onBdIarRRIndividualDetails}
                    onClose={this.handleDetailsModalClose}
                />}

            {!search_executive &&
                <RiaFirmDetailsModal
                    isOpen={this.state.RRBdModal}
                    rowId={this.state.RRBdRowId}
                    listRow={this.state.riaDetailsId}
                    onModalChanged={this.handleIndividualDetails}
                    onClose={this.handleDetailsModalClose}
                />}

            <RRIndivDetailsModal
                isOpen={this.state.iarIndivDetailsModal}
                rowId={this.state.rowId}
                listValue={this.state.riaDetailsId}
                rowIndiv={this.state.iarDetailsId}
                onModalChanged={this.onBdIarIndividualDetails}
                onIarModalChanged={search_executive ? this.onBdIarRRIndividualDetails : this.handleIndividualDetails}
                onClickChanged={this.handleIarIndividualDetails}
                onClose={this.handleIarDetailsModalClose} />

            <BdFirmDetailsModal
                isOpen={this.state.IarModal}
                rowId={this.state.bdRiaRowId}
                listRow={this.state.hasProfileModel}
                onBdModalChanged={this.onIarIndividualDetails}
                onModalChanged={this.handleIarIndividualDetails}
                onClose={this.handleIarDetailsModalClose} />

        </>
    }
}

const mapStateToProps = storeState => ({
    allFormStates: storeState.FirstClassData.formStates,
});

export default connect(mapStateToProps)(RiaFirmSearchResultsPage)